export const ACTIONS = <const>{
	DISABLE: 'DISABLE',
	ENABLE: 'ENABLE',
	END: 'END',
	HOME: 'HOME',
	NEXT_ITEM: 'NEXT_ITEM',
	NEXT_PAGE: 'NEXT_PAGE',
	PREV_ITEM: 'PREV_ITEM',
	PREV_PAGE: 'PREV_PAGE',
	SET_ACTIVE: 'SET_ACTIVE',
	SET_ACTIVE_ITEM: 'SET_ACTIVE_ITEM',
	SET_INTERACTING_WITH_ITEM: 'SET_INTERACTING_WITH_ITEM',
	SET_PAGE_SIZE: 'SET_PAGE_SIZE',
	SET_TOTAL: 'SET_TOTAL',
};
